import { ReactComponent as GoogleIcon } from '../../assets/google-icon.svg';
import { ReactComponent as AppleIcon } from '../../assets/apple-icon.svg';
import { ReactComponent as PlusIcon } from '../../assets/plus-icon.svg';
import { ReactComponent as MinusIcon } from '../../assets/minus-icon.svg';
import { ReactComponent as ListIcon } from '../../assets/list.svg';
import { ReactComponent as GridIcon } from '../../assets/grid.svg';
import { ReactComponent as FilterIcon } from '../../assets/filter-icon.svg';
import { ReactComponent as OrderAscendingIcon } from '../../assets/order-ascending.svg';
import { ReactComponent as OrderDescendingIcon } from '../../assets/order-descending.svg';
import { ReactComponent as DateAscendingIcon } from '../../assets/date-ascending.svg';
import { ReactComponent as DateDescendingIcon } from '../../assets/date-descending.svg';
import { ReactComponent as ChevronLeft } from '../../assets/chevron-left-icon.svg';
import { ReactComponent as ChevronRight } from '../../assets/chevron-right-icon.svg';
import { ReactComponent as ChevronDown } from '../../assets/chevron-down.svg';
import { ReactComponent as XCrossIcon } from '../../assets/xcross-icon.svg';
import { ReactComponent as MeestBarCodeIcon } from '../../assets/barcode.svg';
import { ReactComponent as UniversalCodeIcon } from '../../assets/code-icon.svg';
import { ReactComponent as PolonezBarCodeIcon } from '../../assets/polonez-barcode.svg';
import { ReactComponent as MeestQrCodeIcon } from '../../assets/qrcode.svg';
import { ReactComponent as PolonezQrCodeIcon } from '../../assets/polonez-qrcode.svg';
import { ReactComponent as AddressBook } from '../../assets/address-book.svg';
import { ReactComponent as LoginIcon } from '../../assets/login-icon.svg';
import { ReactComponent as ArrowLeftIcon } from '../../assets/arrow-left.svg';
import { ReactComponent as LocationCrossIcon } from '../../assets/location-cross-icon.svg';
import { ReactComponent as MapIcon } from '../../assets/map.svg';
import { ReactComponent as SortingIcon } from '../../assets/arrows-up-down.svg';
import { ReactComponent as WaffleMenuIcon } from '../../assets/waffles-icon.svg';
import { client } from '../../config';

export type ButtonIconGlyph =
  | 'plus'
  | 'minus'
  | 'google'
  | 'apple'
  | 'list'
  | 'grid'
  | 'filter'
  | 'order-ascending'
  | 'order-descending'
  | 'date-ascending'
  | 'date-descending'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-down'
  | 'x-cross'
  | 'bar-code'
  | 'qr-code'
  | 'code'
  | 'address-book'
  | 'login'
  | 'arrow-left'
  | 'location-cross'
  | 'map'
  | 'sorting'
  | 'waffle-menu';

type Icon = {
  [key in ButtonIconGlyph]: React.ReactNode;
};
const getQrCodeIcon = () => {
  const icons = {
    meest: <MeestQrCodeIcon />,
    polonez: <PolonezQrCodeIcon />,
  };
  return icons[client];
};
const getBarCodeIcon = () => {
  const icons = {
    meest: <MeestBarCodeIcon />,
    polonez: <PolonezBarCodeIcon />,
  };
  return icons[client];
};
export const icons: Icon = {
  plus: <PlusIcon />,
  minus: <MinusIcon />,
  google: <GoogleIcon />,
  apple: <AppleIcon />,
  list: <ListIcon />,
  grid: <GridIcon />,
  filter: <FilterIcon />,
  login: <LoginIcon />,
  map: <MapIcon />,
  sorting: <SortingIcon />,
  'order-ascending': <OrderAscendingIcon />,
  'order-descending': <OrderDescendingIcon />,
  'date-ascending': <DateAscendingIcon />,
  'date-descending': <DateDescendingIcon />,
  'chevron-left': <ChevronLeft />,
  'chevron-right': <ChevronRight />,
  'chevron-down': <ChevronDown />,
  'x-cross': <XCrossIcon />,
  'bar-code': getBarCodeIcon(),
  'qr-code': getQrCodeIcon(),
  'address-book': <AddressBook />,
  'arrow-left': <ArrowLeftIcon />,
  'location-cross': <LocationCrossIcon />,
  code: <UniversalCodeIcon />,
  'waffle-menu': <WaffleMenuIcon />,
};

export const getIcon = (icon: ButtonIconGlyph) => icons[icon];
